import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import "./BlogPostPage.scss";
import { getBlogPosts } from "../BlogPage/lib/getBlogPosts";
import Container from "../../shared/ui/Container";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";

const BlogPostPage = () => {
  const options = {
    renderNode: {
      [BLOCKS.HEADING_2]: (node, children) => (
        <h2 className="blog-post__heading">{children}</h2>
      ),
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <p className="blog-post__paragraph">{children}</p>
      ),
      [INLINES.HYPERLINK]: (node, children) => (
        <a href={node.data.uri}>
          {children}
        </a>
      ),
    },
  };
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    getBlogPosts().then((posts) => {
      const found = posts.find((p) => p.fields.slug === slug);
      setPost(found);
    });
  }, [slug]);

  if (!post) return <p>Loading...</p>;

  return (
    <div className="blog-post">
      <section className="page-header" aria-labelledby="page-title">
        <Container>
          <h1 className="page-header__title">{post.fields.title}</h1>
        </Container>
      </section>

      <section className="blog-post__section">
        <article className="blog-post__content">
            {documentToReactComponents(post.fields.article, options)}
        </article>
      </section>
    </div>
  );
};

export default BlogPostPage;
